import { api } from "@/shared/libs/axiosClient";

interface FindS3KeysRequest {
  dwAccountId: string;
  reportType: string;
  startDate: string;
  endDate: string;
}

interface FindS3KeysResponse {
  s3Keys: string[];
}

interface DeleteS3KeysResponse {
  deletedCount: number;
  errors: string[];
}

/**
 * S3에서 AppsFlyer raw 파일 키 목록 조회
 */
export async function findAppsflyerS3Keys(params: FindS3KeysRequest): Promise<string[]> {
  const response = await api.post<FindS3KeysResponse>("/appsflyer-raw-delete/find-keys", params);
  return response.s3Keys;
}

/**
 * S3에서 AppsFlyer raw 파일 삭제
 */
export async function deleteAppsflyerS3Keys(s3Keys: string[]): Promise<DeleteS3KeysResponse> {
  return api.post<DeleteS3KeysResponse>("/appsflyer-raw-delete/delete-keys", {
    s3Keys,
  });
}
